
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resource-how-to-be-manager",
      function () {
        return require("private-next-pages/resource-how-to-be-manager.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resource-how-to-be-manager"])
      });
    }
  